import Vue from 'vue';
import injector from 'vue-inject';
import store from '../store';

const api = injector.get('api');

class FNProductPacks {
    fetchData() {
        Vue.http.get(api.transferToFN.history)
            .then(response => {
                store.commit('setFNProductPacks', response.body.results);
            });
    }
}

injector.service('fnproductPacks', FNProductPacks);



// WEBPACK FOOTER //
// ./src/services/fnproductPacks.js